export const webinarCycleVariants = {
  nwcWebinar: 'NWC_WEBINAR_CYCLES',
  defaultIitiansWebinar: 'DEFAULT_IITIANS_WEBINAR_CYCLES',
};
